module.exports = (__webpack_require__(0))(8);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/router.js from dll-reference girder_lib
// module id = 12
// module chunks = 0